import script from "./EditReplacementCandidateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditReplacementCandidateModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__